export default "__VITE_ASSET__CClR2slK__"